import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useRemediation } from '../context/RemediationContext';
import RemediationStats from '../components/remediation/RemediationStats';
import RemediationTable from '../components/remediation/RemediationTable';
import TriggerSimulationPanel from '../components/remediation/TriggerSimulationPanel';
import WorkflowTimeline from '../components/remediation/WorkflowTimeline';
import NotificationsPanel from '../components/remediation/NotificationsPanel';
import ActivityLog from '../components/remediation/ActivityLog';
import LearnerRiskTable from '../components/remediation/LearnerRiskTable';
import PageHeader from '../components/ui/PageHeader';

const { FiList, FiUsers, FiActivity } = FiIcons;

const TABS = [
  { id: 'remediations', label: 'Remediations', icon: FiList     },
  { id: 'learners',     label: 'Learner Risk', icon: FiUsers    },
  { id: 'log',          label: 'Activity Log', icon: FiActivity },
];

const Remediation = () => {
  const { learners } = useRemediation();
  const [tab, setTab] = useState('remediations');

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6 max-w-[1400px] mx-auto">
      <PageHeader
        eyebrow="Response"
        title="Remediation"
        description="Auto-assign training on phishing failures, track remediation and adjust risk scores."
      />

      <RemediationStats />

      <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
        <div className="xl:col-span-3 space-y-5">
          <div className="flex gap-1 bg-white border border-slate-200 rounded-lg p-1 shadow-sm w-fit">
            {TABS.map(t => (
              <button key={t.id} onClick={() => setTab(t.id)}
                className={`flex items-center gap-2 px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${tab === t.id ? 'bg-[#0f172a] text-white' : 'text-slate-600 hover:bg-slate-100'}`}>
                <SafeIcon icon={t.icon} className="text-sm" />{t.label}
              </button>
            ))}
          </div>
          {tab === 'remediations' && <RemediationTable />}
          {tab === 'learners' && <LearnerRiskTable />}
          {tab === 'log' && <ActivityLog />}
        </div>
        <div className="space-y-5">
          <TriggerSimulationPanel learners={learners} />
          <NotificationsPanel />
          <WorkflowTimeline />
        </div>
      </div>
    </motion.div>
  );
};

export default Remediation;